import { render, staticRenderFns } from "./roomMediator.vue?vue&type=template&id=54bdaaf6&"
import script from "./roomMediator.vue?vue&type=script&lang=js&"
export * from "./roomMediator.vue?vue&type=script&lang=js&"
import style0 from "./roomMediator.vue?vue&type=style&index=0&id=54bdaaf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports